export default __webpack_public_path__ + "static/media/photo7.eed98e99.jpg";